import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name appMemoryService
     * @memberof app
     *
     * @description
     * A service to get values from the storage rather than firing a new request against the backend.
     * If nothing in the storage is available, the backend will still be asked. You can call methods like services.
     *
     * @example
        appMemoryService.platformSettings(function (res) {
            // Success callback with either the res from the backend or storage.
        }, function (err) {
            // Error callback if the request to the backend was necessary and failed.
        }).$promise.finally(function () {
            // Finally block.
        });
     *
     * @author flzemke.btc
     */
    angular.module('app').service('appMemoryService', appMemoryService);

    function appMemoryService(
        $q,
        storageService,
        ShipperUser,
        APP_MEMORY_STORAGE_KEY,
        platformSettingsService,
        authService
    ) {
        return {
            platformSettings: platformSettings
        };

        function platformSettings(success, failure) {
            authService.userLoginPromise.promise.then(function (loggedInUser) {
                if (!loggedInUser) {
                    return asPromise(failure, 'unauthenticated');
                }
            });

            var platformSettingsFromStorage = storageService.fetchFromLocal(
                APP_MEMORY_STORAGE_KEY.PLATFORM_SETTINGS
            );

            if (
                platformSettingsService.isValidPlatformSettings(
                    platformSettingsFromStorage
                )
            ) {
                return asPromise(success, platformSettingsFromStorage);
            }

            return ShipperUser.getSettings(
                { setting: 'platform' },
                function (res) {
                    success(res);
                },
                function (err) {
                    failure(err);
                }
            );
        }

        function asPromise(callback, res) {
            return {
                $promise: $q(function (resolve) {
                    resolve(callback(res));
                })
            };
        }
    }
})();
